import { render, staticRenderFns } from "./teachingPointForm.vue?vue&type=template&id=90c005b4&scoped=true&"
import script from "./teachingPointForm.vue?vue&type=script&lang=js&"
export * from "./teachingPointForm.vue?vue&type=script&lang=js&"
import style0 from "./teachingPointForm.vue?vue&type=style&index=0&id=90c005b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c005b4",
  null
  
)

export default component.exports